export default __webpack_public_path__ + "static/media/icon-adresse.4cc592e9.svg";